import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class PosproductService {


  url = environment.serverAPI9 + "/api/posproducts";

  ur12 = environment.serverAPI5 + "/api/productViewreport";
  ur2 = environment.serverAPI5 + "/api";
  url8 = environment.serverAPI + "/api/core/exceltemplate/";
  ur13 = environment.serverAPI5 + "/api/productViewreportNew";

  currentWarehouseId: any = '0';

  constructor(private http: HttpClient,
    private loginService: LoginService
  ) { }

  getAllProduct(Page: any, size: any, sort: any, warehouseId: any): Observable<Object> {
    let isDownloadComponentCall = false;
    if (warehouseId && typeof warehouseId === 'string' && warehouseId.includes(',')) {
      isDownloadComponentCall = true;
    } else if (Page === null || Page === undefined || (typeof Page === 'string' && isNaN(Number(Page)))) {
      isDownloadComponentCall = true;
    }

    let actualPage = Page;
    let actualSize = size;
    let actualSort = sort;
    let actualWarehouseId = warehouseId;

    if (isDownloadComponentCall) {
      actualPage = size;
      actualSize = sort;
      actualSort = warehouseId;
      actualWarehouseId = this.currentWarehouseId;
    }

    const wid = actualWarehouseId ?? this.currentWarehouseId ?? 0;

    return this.http.get(`${this.url}?page=${actualPage}&size=${actualSize}&sort=${actualSort}&warehouseId=${wid}`);
  }

  /**
   * NEW: Warehouse-filtered product listing.
   * Calls /api/posproducts/warehouse-filtered to return ONLY products belonging to the specified warehouse.
   * The existing getAllProduct() is not modified.
   */
  getWarehouseFilteredProducts(page: any, size: any, sort: any, warehouseId: any): Observable<Object> {
    return this.http.get(`${this.url}/warehouse-filtered?page=${page}&size=${size}&sort=${sort}&warehouseId=${warehouseId}`);
  }

  getAllProductDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getProductById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  getProductViewReportById(productId: number): Observable<Object> {
    return this.http.get(`${this.ur13}/${productId}`);
  }

  getWarehouseProductById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/quantityProduct/${id}`);
  }
  addOrEditProduct(products: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, products);
  }

  ProductSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    const wid = this.currentWarehouseId ?? 0;
    const warehouseParam = (wid && String(wid) !== '0') ? `&warehouseId=${wid}` : '';
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}${warehouseParam}`);
  }
  deleteByProductId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  deleteAllPosProducts(): Observable<Object> {
    return this.http.delete(`${this.url}/all`);
  }

  deleteBySelectedIds(productIds: any[]): Observable<Object> {
    return this.http.post(`${this.url}/delete/selected`, productIds);
  }

  deleteImage(data: any): Observable<Object> {
    return this.http.post(`${this.url}/deleteImage`, data);
  }

  uploadImageZip(data: FormData, id: any = 0, productIds: any = 0): Observable<Object> {
    return this.http.post(`${this.url8}upload/zip/${id}?key=${productIds}`, data);
  }

  productSaleSearch(query, Page: any, size: any, sort: any, value): Observable<Object> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
      "searchEntity": value

    };
    return this.http.post(`${this.url}/warehouse/condition?page=${Page}&size=${size}&sort=${sort}`, requestBody);
  }

  downloadProductTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  downloadReport() {
    return this.http.get(`${this.url}/exceltemplate/export`, { responseType: 'arraybuffer', observe: 'response' });
  }


  getShopData(): Observable<Object> {
    return this.http.get(`${this.url}/products`);
  }

  saveShopSetting(products: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/products`, products);
  }
  excelImportProductQtyAndPrice(data: FormData): Observable<Object> {
    return this.http.post(`${this.ur2}/product/update/upload`, data);
  }
  downloadProductsReport(Page: number, size: number, sort, selectionProduct): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
    &size=${size}&sort=${sort}`, selectionProduct, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }

  getProductByCategoryId(id: number): Observable<Object> {

    let authourized = this.loginService.getAuthenticatedUser();
    if (authourized) {
      return this.http.get(`${this.url}/categroyData/${id}`);
    }
    else {
      return this.http.get(`${this.url}/ig/categroyData/${id}`);
    }
  }

  getProductByCategoryIdUnauthorized(id: number): Observable<Object> {
    return this.http.get(`${this.url}/ig/categroyData/${id}`);
  }

  getProductByBrandId(id: number): Observable<Object> {
    return this.http.get(`${this.url}/brand/${id}`);
  }


  getProductQuantity(productId: number): Observable<Object> {
    return this.http.get(`${this.url}/productquantity/${productId}`);
  }


  productCodeVerified(code: any, productId: any = 0): Observable<Object> {
    return this.http.get(`${this.url}/code/${code}?productId=${productId}`);
  }

  productNameVerified(name: any, productId: any = 0): Observable<Object> {
    return this.http.get(`${this.url}/name/${name}?productId=${productId}`);
  }

}
